import { Injectable } from '@angular/core';
import * as fromAuth from '@app/auth/reducers';
import {
  getAgency,
  getAgencyId,
  getAgencyTypeId,
  getCountryOfUserAgency,
  getDefaultDossierView,
  getDefaultPageSize,
  getFilterId,
  getUserId,
  isAdmin,
  isApplicantUser,
  isCossUser,
  isImUser,
  isIntegrationPlatformUser,
  isPassengerApplicantUser,
  isReadonlyUser,
  isRneJo,
  isRu
} from '@app/core/utils';
import { Agency, User } from '@app/models';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import * as R from 'ramda';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
  user$: Observable<User>;
  user: User;

  constructor(private store: Store<fromRoot.State>) {
    this.user$ = this.store.pipe(select(fromAuth.getUser));
    this.user$.subscribe((user) => {
      this.user = user;
    });
  }

  getId() {
    return getUserId(this.user);
  }

  getAgency() {
    return getAgency(this.user);
  }

  getAgencyId() {
    return getAgencyId(this.user);
  }

  getAgencyTypeId() {
    return getAgencyTypeId(this.user);
  }

  getCountryOfUserAgency() {
    return getCountryOfUserAgency(this.user);
  }

  getDefaultPageSize() {
    return getDefaultPageSize(this.user);
  }

  isApplicantUser() {
    return isApplicantUser(this.user);
  }

  isPassengerApplicantUser() {
    return isPassengerApplicantUser(this.user);
  }

  isImUser() {
    return isImUser(this.user);
  }

  isCossUser() {
    return isCossUser(this.user);
  }

  isAdmin() {
    return isAdmin(this.user);
  }

  isRneJo() {
    return isRneJo(this.user);
  }

  isRu() {
    return isRu(this.user);
  }

  isIntegrationPlatform() {
    return isIntegrationPlatformUser(this.user);
  }

  isReadonlyUser() {
    return isReadonlyUser(this.user);
  }

  getUser() {
    return this.user;
  }

  getDefaultTrainType() {
    return this.getPersonalSettings().defaultTrainType;
  }

  getDefaultFilterId() {
    return getFilterId(this.user);
  }

  getDefaultDossierView() {
    return getDefaultDossierView(this.user);
  }

  updateAgency(agency: Agency) {
    this.user = R.mergeRight(this.user, {agency});
  }

  getFullScreenMode() {
    return this.getPersonalSettings().fullScreenMode;
  }

  getDossierSideMenuCollapsed() {
    return this.getPersonalSettings().dossierSideMenuCollapsed;
  }

  private getPersonalSettings() {
    return this.user.personalSettings;
  }
}
